import { components } from "@certn/legacy-api/generated-schemas/people";

export function getNumMissingDocuments(
  documents: components["schemas"]["IdentificationDocumentsCheckField"]["value"]
) {
  const subtypes = new Set();
  let secondaryDocumentsNum = 0;
  documents.forEach(({ document_subtype }) => {
    subtypes.add(document_subtype);

    if (document_subtype === "secondary") {
      secondaryDocumentsNum += 1;
    }
  });

  let count = 0;

  if (!subtypes.has("commencement")) {
    count += 1;
  }

  if (!subtypes.has("primary")) {
    count += 1;
  }

  if (secondaryDocumentsNum < 2) {
    count += 2 - secondaryDocumentsNum;
  }

  return count;
}
